import { render, staticRenderFns } from "./test.html?vue&type=template&id=224172d4&"
import script from "./test.js?vue&type=script&lang=js&"
export * from "./test.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports